// we should think about moving the SDK exports away from the component and into this service layer
import type { SdkConfigFieldBase } from '../../editor/components/MenuBar/MenuBarModals/ThreeDotsModals/SDKConfigModal/types';


export function isSdkPluginEmpty(plugin: string) {
  return plugin === null || plugin === '';
}

export function isSdkFieldEmpty(field: SdkConfigFieldBase) {
  const { value } = field;
  return value === null || value === '';
}

export function getFieldsForPlugin(fields: SdkConfigFieldBase[], plugin: string) {
  return fields.filter(f => f.plugin === plugin);
}
